import * as React from 'react';
import {flow, forEach, map, mapValues, filter, cloneDeep, size, get, find} from 'lodash';
import { II18nMessages } from '../../../../services/branding/models';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Field, FieldArray, formValueSelector, InjectedFormProps, reduxForm, submit, reset, destroy } from 'redux-form';
import { isRequired } from '../../../../util/validators';
import TravellersMedical from './components/TravellersMedical';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IChannel, IDeclaration, IProduct, ITraveller } from '../../../../data/api/models';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import FieldFormControl from '../../../../components/FieldFormControl/index';
import * as ReactMarkdown from 'react-markdown';
import confirm from 'react-confirm2';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import FaChevronRight from 'react-icons/fa/chevron-right';
import { IStore } from '../../../../redux/IStore';
import * as Commonmark from 'react-commonmark';
import { WarningMessages } from '../Verisk/scenes/WarningMessages';
import { IVeriskState } from '../../../../services/verisk/models';
import { go } from 'react-router-redux';

// tslint:disable:max-line-length
// FIXME: This should come from the API!
const WARNING_MESSAGE = {
  default: `We notice that you have ticked ‘Yes’ to one or more of the Medical Screening questions,
              but you have not declared any medical conditions. Unfortunately, if you do not declare
              all relevant medical conditions, your policy could get cancelled,
              claim payments refused or your claim rejected.
              Are you happy to proceed?`,
  MPT: `We notice that you have ticked ‘Yes’ to one or more of the Medical Screening questions, but you have not declared any medical conditions. Unfortunately, if you do not declare all relevant medical conditions, your policy could get cancelled, claim payments refused or your claim rejected. Are you happy to proceed?\n\n **IMPORTANT NOTE** : If you or anyone else to be insured reside in the United Kingdom or the Isle of Man and your trip is to or within the United Kingdom or the Isle of Man, you do not need to declare any medical conditions. Please click **OK** to continue.`,
  LSB: `As you have answered ‘Yes’ to one or more of the Medical Screening questions, you must now contact Travel Administration Facilities at [www.pjhlongstay.protectif.co.uk](http://www.pjhlongstay.protectif.co.uk) or call them on 0203 829 3855. They will tell you if your pre-existing medical condition/s can be covered. This can be done when you save the quote or after purchasing cover.\n\n **Please note:** We are unable to provide any cover for your medical pre-existing condition, unless we have agreed cover in writing and any additional premium has been paid.`,
};

interface IMedicalDeclaration extends InjectedFormProps {
  i18n: II18nMessages;
  product: IProduct;
  pristine: boolean;
  quote: IQuoteState;
  submitting: boolean;
  onBack: () => void;
  dispatch: any;
  traveller: ITraveller;
  travellers: ITraveller[];
  channel: IChannel;
  medicalDeclaration: IDeclaration[];
  cancelMedicalDeclaration: boolean;
  renderDefinition(name: string): any;
  actions: {
    submit(name: string);
    quote: IQuoteActions;
    reset(formName: string);
    destroy(formName: string);
  };
  verisk: IVeriskState;
  goingOnCruise: boolean;
}

interface IMedicalDeclarationState {
  isScreening: boolean;
  isTerminal: boolean;
  isAnyModalOpen: boolean;
  unableToProvideQuote: boolean;
  cancelMedicalDeclaration: boolean;
}

class MedicalDeclaration extends React.Component<IMedicalDeclaration, IMedicalDeclarationState> {
  public state = {
    isScreening: false,
    isTerminal: false,
    isAnyModalOpen: false,
    unableToProvideQuote: false,
    cancelMedicalDeclaration: false,
  };

  public componentWillMount() {
    const { product, change, medicalDeclaration, dispatch, quote } = this.props;
    const steps = quote.application.steps;
    let allowEmailSendLogic = true;

    forEach(steps, (step) => {
      if (step.match(/(schemeChoice)/)) {
        allowEmailSendLogic = false;
      }
    });

    if (allowEmailSendLogic) {
      dispatch(change('emailSend', true));
    }

    if (size(medicalDeclaration) === 0) {
      change(
        'medicalDeclaration',
        mapValues(cloneDeep(
          product.metadata.medical_declaration_questions),
          (declaration) => ({ ...declaration, answer: undefined }),
        ),
      );
    }
  }

  private shouldShowScreeningSection = () => {
    const { medicalDeclaration } = this.props;

    if (! medicalDeclaration) {
      return false;
    }

    const allQuestions = filter(medicalDeclaration, (question) => {
      return question.question_type === 'boolean';
    });

    const medicalQuestions = filter(medicalDeclaration, (question) => question.category === 'medical' || question.prompt_single_quote);
    const unanswered = filter(allQuestions, (question) =>
      question.answer === undefined && question.question_type === 'boolean',
    );
    const trueAnswers = filter(medicalQuestions, (question) => question.answer === true);

    return unanswered.length === 0 && trueAnswers.length > 0;
  }

  private setIsScreening = (isScreening: boolean) => {
    this.setState({
      isScreening,
    });
  }

  private checkForTerminalCondition = (item) => {
    // const { actions, quote } = this.props;
    if (item.category === 'health' && item.answer === true) {
      // this.setState({ unableToProvideQuote: true });
      // actions.quote.referralQuote(quote.application.id, null);
    }
  }

  private renderMedicalQuestion = (item, key) => {
    let component = null;

    if (item.question_type === 'boolean') {
      component = [
        (
          <Col xs={6} key={1}>
            <Field
              name={`medicalDeclaration[${key}].answer`}
              id={`medicalDeclaration[${key}].answerYes`}
              type="radio"
              format={null}
              value={true}
              complexValue={true}
              className="answer"
              component={FieldFormControl}
              validate={[ isRequired ]}
              onClick={this.checkForTerminalCondition(item)}
            >
              <div className="medical-btn yes">
                Yes
              </div>
            </Field>
          </Col>
        ),
        (
          <Col xs={6} key={2}>
            <Field
              name={`medicalDeclaration[${key}].answer`}
              id={`medicalDeclaration[${key}].answerNo`}
              type="radio"
              format={null}
              value={false}
              complexValue={true}
              className="answer"
              component={FieldFormControl}
              validate={[ isRequired ]}
            >
              <div className="medical-btn no">
                No
              </div>
            </Field>
          </Col>
        ),
      ];
    }

    if (item.question_type === 'number') {
      component = (
        <div>
          <Field
            name={`medicalDeclaration[${key}].answer`}
            className="answer-number"
            component={FieldFormControl}
          />
        </div>
      );
    }

    return (
      <div className="medical-question medical-section" key={key}>
        <Row>
          <Col sm={12}>
            <ReactMarkdown source={item.content} />
          </Col>
          <Col sm={4}>
            {component}
          </Col>
        </Row>
      </div>
    );
  }

  private renderMedicalHeader = (item, key) => {
    const { channel } = this.props;

    if (channel.key === 'lsb-b2c') {
      return (
        <div key={key}>
          <p>
            <Commonmark
              source={item.content}
              linkTarget="_blank"
              transformLinkUri={this.transformLinks}
            />
          </p>
        </div>
      );
    }

    return (
      <div key={key}>
        <p>
          <ReactMarkdown
            source={item.content}
            renderers={{
              link: (props) => (
                <a href={props.href} target="_blank">
                  {props.children}
                </a>
              ),
            }}
          />
        </p>
      </div>
    );
  }

  public renderQuestions(category) {
    const { medicalDeclaration } = this.props;

    const displayKeys = [];

    forEach(medicalDeclaration, (declaration: IDeclaration, key) => {
      const answer = declaration.answer;
      const questionType = declaration.question_type;

      if (questionType === 'boolean' && answer === 'true') {
        if (declaration.next_key) {
          displayKeys.push(declaration.next_key);
        }

        if (declaration.true_key) {
          displayKeys.push(declaration.true_key);
        }
      }

      if (questionType === 'boolean' && answer === 'false') {
        if (declaration.next_key) {
          displayKeys.push(declaration.next_key);
        }

        if (declaration.false_key) {
          displayKeys.push(declaration.false_key);
        }
      }
    });

    return (
      <div className="medical-questions-container">
        {map(medicalDeclaration, (question: any, key) => {
          let component;

          if (question.display === false && displayKeys.indexOf(key) === -1) {
            return null;
          }

          if (['header', 'footer'].includes(question.type) && category === question.category) {
            component = this.renderMedicalHeader(question, key);
          }

          if (question.type === 'question' && category === question.category) {
            component = this.renderMedicalQuestion(question, key);
          }

          return component;
        })}
      </div>
    );
  }

  private transformLinks = (url) => {
    const { product, channel } = this.props;

    if (url === 'policy_wording' || url === 'Insurance Policy') {
      const pwDocument = find(channel.productDocuments, (document) => {
        return document.shortName === 'Insurance Policy';
      });

      if (pwDocument) {
        return pwDocument.filePath;
      }
    }

    if (url === 'covid_statement' || url === 'Coronavirus factsheet') {
      const csDocument = find(channel.productDocuments, (document) => {
        return document.shortName === 'Coronavirus Factsheet';
      });

      if (csDocument) {
        return csDocument.filePath;
      }
    }

    if (url === 'policy_summary') {
      return product.documents[ 'Policy Summary' ];
    }

    return url;
  }
  private continueOn = () => {
    const { actions } = this.props;
    actions.submit('quote');
  }

  private checkIfConditionWasDeclared = () => {
    const { travellers, medicalDeclaration, actions, product } = this.props;

    const allQuestions = filter(medicalDeclaration, (question) => question.type === 'question');
    const unanswered = filter(allQuestions, (question) =>
      question.answer === undefined && question.question_type === 'boolean',
    );

    const MedicalQuestions = filter(medicalDeclaration, (question) => question.category === 'medical');
    const medicalTrueAnswers = filter(MedicalQuestions, (question) => question.answer === true);

    const travellerScreening = filter(travellers, (traveller) => traveller.screening);
    const travellersLength = travellers.length;

    const shouldScreen = unanswered.length === 0 && medicalTrueAnswers.length > 0;

    if (!shouldScreen) {
      actions.submit('quote');
      // this.agreementBeforeSubmit();
    }

    if (shouldScreen && travellerScreening.length === travellersLength) {
      actions.submit('quote');
      // this.agreementBeforeSubmit();
    }

    if (shouldScreen && travellerScreening.length < travellersLength && travellerScreening.length === 0) {
      actions.submit('quote');
    }

    if (shouldScreen && travellerScreening.length < travellersLength && travellerScreening.length > 0) {
      actions.submit('quote');
      // this.agreementBeforeSubmit();
    }
  }

  public render() {
    const {
      i18n,
      product,
      handleSubmit,
      medicalDeclaration,
      submitting,
      valid,
      change,
      submitFailed,
      channel,
      quote,
      onBack,
      cancelMedicalDeclaration,
      verisk,
      goingOnCruise,
    } = this.props;
    const { metadata } = product;
    const { isAnyModalOpen, unableToProvideQuote } = this.state;

    const medicalHeader = get(product, 'metadata.purchase_declaration.b2c.medical_screening.header');
    const medicalFooter = get(product, 'metadata.purchase_declaration.b2c.medical_screening.footer');

    if (! medicalDeclaration) {
      return false;
    }

    const showCancelMedicalDeclaration = ['TPL', 'FST', '247', 'VEN'].includes(product.productCode);
    const getHeaderFromApi = ['TPL', 'MPT', 'FST', '247', 'VEN'].includes(product.productCode);
    const upperCaseList = ['tpl-b2c', 'mpt-b2c'];
    const renderTitle = (upperCaseList.indexOf(channel.key) !== -1) ? 'Medical' : 'MEDICAL';
    // FIXME: This should be in the medical declaration content as a paragraph
    const renderPreQuestion = !['FST'].includes(product.productCode)
      ? null
      : 'Are you or anyone else to be insured on this policy:';

    const subtitleClass = ['medical-subtitle', channel.key === 'tpl-b2c' && '--pb5' ].join('');
    const customClassList = ['tpl-b2c', 'mpt-b2c'].includes(channel.key);
    const sectionClass = ['section padding-bottom-0 ', customClassList && 'section--noBorder' ].join('');
    const callMessage = {
      free: 'Simply call our UK-based specialist customer service team FREE on',
      cost: 'Simply call our UK-based specialist customer service team on',
    };
    const productCallMessage = {
      FST: callMessage.free,
      TPL: callMessage.cost,
      MPT: callMessage.cost,
    };

    let  understandMedicalDeclaration = cancelMedicalDeclaration;

    if (!showCancelMedicalDeclaration) {
      understandMedicalDeclaration = true;
    }

    const quoteReference = quote.application.quoteReference && quote.application.quoteReference;

    let showMedicalQuestions = true;
    const tripType = quote.application.tripType;
    const isFST = ['FST'].includes(product.productCode);
    if (isFST && !goingOnCruise) {
      if (tripType === 'single') {
        if (quote.application.destinations.length === 1 && quote.application.destinations[0] === 'United Kingdom') {
          showMedicalQuestions = false;
        }
      }
      if (tripType === 'annual') {
        if (quote.application.region === 'uk') {
          showMedicalQuestions = false;
        }
      }
    }
    return (
      <Form onSubmit={handleSubmit} autoComplete="off">
        <div className="steps-container">
          <div className="section-title">
            <h1>{renderTitle}</h1>
          </div>
          {!unableToProvideQuote ? (
            <div className="medical-section-group">
              <div className={sectionClass} style={{ marginBottom: '0' }}>
                <Row>
                  {!showMedicalQuestions ? (
                    <div>
                      <b>UK only trips</b>
                      <p>
                        As you are travelling within the UK, we won’t need to take you through any medical screening questions.
                        You will need to be <b>fit to travel</b> and undertake your planned trip to be covered under this insurance.
                        You will not be covered under this policy for any claims in any way related to any <b>existing medical condition</b>, unless you can comply with the following:
                      </p>
                      <ol>
                        <li>You are <b>fit to travel</b> and undertake your planned trip when you take out this policy, book your trip, paying instalments/final balance or at the time you travel (whichever is later).</li>
                        <li>Following any claim investigation, your medical practitioner confirms they would have agreed with or recommended your travel plans when you took out this policy, booked your trip, paying instalments/final balance or at the time you travelled (whichever is later).</li>
                        <li>You are not travelling to have medical treatment or a consultation during your trip</li>
                      </ol>
                      <b>What does fit to travel mean?</b>
                      <p>Being medically fit to travel means:</p>
                      <ul>
                        <li>any existing medical condition(s) you have must be stable and controlled by any treatment you are receiving and/or medication(s) you have been prescribed; and</li>
                        <li>there must be no known likelihood of any specialist or specific medical tests, investigations or variation of treatment or medication for any existing medical condition(s) when booking your trip, paying instalments/final balance, or whilst travelling; and</li>
                        <li>you are not awaiting surgery for any diagnosed medical condition unless your doctor has confirmed that you are medically fit to travel; and</li>
                        <li>you are not exhibiting symptoms of an existing medical condition which could mean that your trip could be cancelled or cut short.</li>
                      </ul>
                      <p>It is always advisable to consult a medical practitioner if you have any doubts about whether any insured person is medically fit to undertake a trip.</p>
                    </div>
                  ) : (
                    <div>
                      { !getHeaderFromApi && (
                        <div>
                          <div className="internal-title">
                            Important Conditions Relating To Your Health
                          </div>
                          <p className={subtitleClass}>
                            We need to ask you some medical questions about you and anyone else to be
                            insured on the policy to make sure that you have the right cover.
                          </p>
                        </div>
                      )}
                      { getHeaderFromApi && (
                        <div>
                          <ReactMarkdown source={medicalHeader} />
                          {showCancelMedicalDeclaration && (
                            <div>
                              <Row style={{ borderBottom: '1px solid #8dc1e9' }}>
                                <Col xs={4}>
                                  <div className="medical-questions-container">
                                    <div className="medical-question medical-section">
                                      {channel.key !== 'fst-b2c' && (
                                        <p>Do you understand?</p>
                                      )}
                                      <Col xs={6} key={1}>
                                        <Field
                                          name={`cancelMedicalDeclaration`}
                                          type="radio"
                                          format={null}
                                          value={true}
                                          complexValue={true}
                                          className="answer"
                                          component={FieldFormControl}
                                          validate={[ isRequired ]}
                                        >
                                          <div className="medical-btn yes">
                                            Yes
                                          </div>
                                        </Field>
                                      </Col>
                                      <Col xs={6} key={2}>
                                        <Field
                                          name={`cancelMedicalDeclaration`}
                                          id={`cancelMedicalDeclaration.answerNo`}
                                          type="radio"
                                          format={null}
                                          value={false}
                                          complexValue={true}
                                          className="answer"
                                          component={FieldFormControl}
                                          validate={[ isRequired ]}
                                        >
                                          <div className="medical-btn no">
                                            No
                                          </div>
                                        </Field>
                                      </Col>
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={8} />
                                {understandMedicalDeclaration === false && (
                                  <Col xs={12}>
                                    <p style={{color: 'red'}}>You must agree to the above statements before continuing with a quote.</p>
                                  </Col>
                                )}
                              </Row>
                              <div className="internal-title padding-top-internal-title">
                                Important Conditions Relating To Your Health
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      <p>{renderPreQuestion}</p>
                      {this.renderQuestions('health')}
                    </div>
                  )}
                </Row>
              </div>

              {showMedicalQuestions && (
                <div className="section padding-bottom-0" style={{ paddingTop: '0' }}>
                  <Row>
                    {['247', 'FST', 'VEN'].includes(product.productCode) ? (
                      <div>
                        <div className="internal-title">
                          Medical Screening
                        </div>
                        {['FST'].includes(product.productCode) && (
                          <p>
                            Please answer the following questions. If you or anyone else to be insured on
                            this policy answer ‘Yes’ to any of these you will need to go through our medical
                            screening process.
                          </p>
                        )}
                      </div>
                    ) : null}
                    {this.renderQuestions('medical')}
                  </Row>
                </div>
              )}
              {medicalFooter && (
                <div className="section padding-bottom-0" style={{ paddingTop: '0' }}>
                  <Row>
                    <ReactMarkdown
                      source={medicalFooter}
                      renderers={{
                        link: (props) => (
                          <a href={props.href} target="_blank">
                            {props.children}
                          </a>
                        ),
                      }}
                    />
                  </Row>
                </div>
              )}

              {this.shouldShowScreeningSection() && (
                <div className="section padding-bottom-0" style={{ paddingTop: '0' }}>
                  <Row>
                    {channel.key === 'fst-b2c' ? (
                      <>
                        <p>
                        As you have advised us about a medical condition/conditions, please complete a medical screening.
                        </p>
                        <p>
                          To do this, start typing the name of the medical condition in the box below, select the condition from the list, and answer the questions.
                        </p>
                        <p>
                          If you are unsure of any of the answers, please check with your GP.
                        </p>
                        <p>
                          You can’t choose to tell us about some conditions and not others, so it’s important that you answer these questions fully and accurately.
                        </p>
                      </>
                    ) : (
                      <>
                        <p>
                          You have advised us about a medical condition/conditions. Therefore, you will need to complete a
                          medical screening using an automated decision-making tool that does not involve human input.
                          The system will use information you provide—about you and other individuals to be insured under
                          the policy—regarding health and lifestyle to determine whether and on what terms to provide
                          insurance.
                        </p>
                        <p>
                          You have the right not to be subject to a decision that is based solely on automated processing.
                          You do not have to take part in this screening process, but if you don't, we won't be able to
                          provide you with insurance.
                        </p>
                      </>
                    )}
                  </Row>
                </div>
              )}
              <div className="medical-condition-container" hidden={!this.shouldShowScreeningSection()}>
                <div className="section-title">
                  <h2>Your medical condition(s)</h2>
                </div>

                <FieldArray
                  name="travellers"
                  i18n={i18n}
                  change={change}
                  channel={channel}
                  component={TravellersMedical}
                  questions={metadata.medical_declaration_questions}
                  setIsScreening={this.setIsScreening}
                  rerenderOnEveryChange={true}
                />
              </div>

              {verisk.errors && (
                <WarningMessages warningMessage={verisk.errors} />
              )}

              {!showMedicalQuestions ? (
                <div className="btn-bar"  hidden={this.state.isScreening === true} style={{marginTop: '20px'}}>
                  <Button
                    id="continue"
                    bsStyle="primary"
                    onClick={this.continueOn}
                    className="pull-right"
                    disabled={submitting}
                  >
                    Continue <FaChevronRight/>
                  </Button>
                  <Button type="button" className="btn-back" onClick={onBack}>
                    Back
                  </Button>
                </div>
              ) : (
                <div className="btn-bar"  hidden={this.state.isScreening === true} style={{marginTop: '20px'}}>
                  <Button
                    id="continue"
                    bsStyle="primary"
                    onClick={this.checkIfConditionWasDeclared}
                    className="pull-right"
                    disabled={submitting || (submitFailed && !valid) || isAnyModalOpen || !understandMedicalDeclaration}
                  >
                    Continue <FaChevronRight/>
                  </Button>
                  <Button type="button" className="btn-back" onClick={onBack}>
                    Back
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <div className="section">
              <Row className="unable-box">
                <p>Sorry, we are not able to complete your quotation online as we need a few more details.<br/><br/>
                  Simply call our UK-based specialist customer service team on {channel.phone}
                  quoting <b>{quoteReference}</b> who will discuss your requirements with you.<br/><br/>
                  We are open {channel.openingHours}, closed Bank Holidays.
                </p>
              </Row>
            </div>
          )}
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const medicalDeclaration = selector(state, 'medicalDeclaration');
      const travellers = selector(state, 'travellers');
      const steps = selector(state, 'steps');
      const cancelMedicalDeclaration = selector(state, 'cancelMedicalDeclaration');
      const verisk = state.verisk;
      const goingOnCruise = selector(state, 'going_on_cruise');

      return {
        medicalDeclaration,
        travellers,
        steps,
        channel: state.branding.channel,
        quote: state.quote,
        cancelMedicalDeclaration,
        verisk,
        goingOnCruise,
      };
    },
    (dispatch) => ({
      dispatch,
      actions: {
        submit: bindActionCreators(submit, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
        reset: bindActionCreators(reset, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
      },
    }),
  ),
])(MedicalDeclaration);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/MedicalDeclaration/index.tsx